import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectServiceabilityListItems } from "../../../../../../redux/serviceabilities/selector";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { serviceabilities } from "../../../../../../redux/serviceabilities/action";

const ManagementServiceabilities = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectServiceabilityListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
          { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' , isEdit: true },
          { field: 'StartDateUtc', headerName: 'Start Date', isDateValueFormat:true, },
          { field: 'EndDateUtc', headerName: 'End Date', isDateValueFormat:true, },
      
        ]);
      }
      
      
      const fetchServiceabilities=()=>{
        dispatch(serviceabilities.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/serviceabilities/list`,entity:'serviceabilities',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }

      useEffect(() => {
        createColumnDefs()
        fetchServiceabilities()
	}, [pageData,pageSize])
      
      const handleAdd=()=>{
        navigate(`${0}`)
      }

      const handleAddPincode=()=>{
        navigate(`/management/policy/shipment/pin-codes/${0}`)
      }

      const handleDelete=(data: any)=>{
        dispatch(serviceabilities.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/serviceabilities/delete`,
          entity: 'serviceabilities',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        fetchServiceabilities()
      });
      }
     
      const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchServiceabilities()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Vehicle</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 50 50" width="24" height="24">
            <title>Add Pincode</title>
            <path d="M25 0c-8.284 0-15 6.656-15 14.866 0 8.211 15 35.135 15 35.135s15-26.924 15-35.135c0-8.21-6.716-14.866-15-14.866zm-.049 19.312c-2.557 0-4.629-2.055-4.629-4.588 0-2.535 2.072-4.589 4.629-4.589 2.559 0 4.631 2.054 4.631 4.589 0 2.533-2.072 4.588-4.631 4.588z" stroke="currentColor" stroke-width="3.5" fill="none" />
          </svg>,
          // name: 'Add Pincode',
          callback: () => handleAddPincode(),
        },
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
	
        dispatch(serviceabilities.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/serviceabilities/list`,
          entity: 'serviceabilities',
          jsonData: {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
            "Searches": searchCriteria,
          }
      }));
    }
	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
 <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
 enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Serviceability" />
     
  }
  </>
	);
};

export default ManagementServiceabilities;